(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-inquire-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-custom-inquire]');
    if (!link) return;

    // The inquiry form (Powerful Form Builder) lives in an accordion row.
    const row = document.querySelector('.globo-formbuilder')?.closest('details');
    if (!row) return;

    event.preventDefault();
    row.open = true;
    row.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () { document.addEventListener('click', function (e) { var toggle = e.target.closest('[data-cmm-toggle]'); if (toggle) { var item = toggle.closest('.cmm-item'); var open = item.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); return; } if (!e.target.closest('.custom-header__nav .cmm-item')) { document.querySelectorAll('.custom-header__nav .cmm-item.is-open').forEach(function (li) { li.classList.remove('is-open'); }); } }); document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; document.querySelectorAll('.cmm-item.is-open').forEach(function (li) { li.classList.remove('is-open'); var t = li.querySelector('[data-cmm-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }); var active = document.activeElement; if (active && active.closest('.cmm-panel')) { var link = active.closest('.cmm-item').querySelector('.cmm-link'); if (link) link.focus(); } }); document.addEventListener('touchend', function (e) { var link = e.target.closest('.custom-header__nav .has-mega > .cmm-link'); if (!link) return; var item = link.parentElement; if (!item.classList.contains('is-open')) { e.preventDefault(); document.querySelectorAll('.custom-header__nav .cmm-item.is-open').forEach(function (li) { if (li !== item) li.classList.remove('is-open'); }); item.classList.add('is-open'); } }, { passive: false }); })();
  } catch(e) { console.error(e); }
})();

})();
